import { writable, type Writable } from "svelte/store";

export const detailAltText: Writable<string> = writable();
